import { Tooltip } from '@ds';
import { IoMdInformationCircleOutline } from 'react-icons/io';

export const ThirtyDaysLabel = () => {
  return (
    <div className="flex flex-row gap-2 justify-center items-center">
      <span className="text-s-sb uppercase">30 DAYS</span>
      <Tooltip content="Total cases the CS has deployed to in the last 30 days">
        <span className="cursor-help leading-none inline-flex text-s-sb hover:text-base-10">
          <IoMdInformationCircleOutline size={20} />
        </span>
      </Tooltip>
    </div>
  );
};
